import {
  CREDIT_RANGE_LABEL_MAP,
  CREDIT_RANGES,
  CreditRangeEnum,
  type CreditRangeLabel,
} from '@cc-shopping/contracts/credit-cards-page/roundup/utils';
import { FilterOffersByType, SortOffersByType } from './store/enums';

export const CARD_FEATURES_TITLE = 'Card features';
export const ALL_CARDS_CARD_FEATURES_KEY = 'all-cards';

export const CARD_FEATURES_OPTIONS_LABEL_MAP: Record<FilterOffersByType, string> = {
  [FilterOffersByType.ALL_CARDS]: 'All cards',
  [FilterOffersByType.NO_ANNUAL_FEE]: 'No annual fee',
  [FilterOffersByType.HAS_INTRO_OFFER]: 'Has intro offer',
};

export const SORT_BY_OPTIONS_LABEL_MAP: Record<SortOffersByType, string> = {
  [SortOffersByType.FEATURED]: 'Featured',
  [SortOffersByType.HIGHEST_RATING]: 'Highest rating',
  [SortOffersByType.LOWEST_ANNUAL_FEE]: 'Lowest annual fee',
  [SortOffersByType.LOWEST_APR]: 'Lowest APR',
};

export type CreditRangeFilterLabel = `${number} - ${number} (${CreditRangeLabel})`;

/**
 * Map of credit score range enums to their label
 * @example
 * {
 *   [CreditRangeEnum.EXCELLENT]: '720 - 850 (Excellent)',
 * }
 */
export const CREDIT_RANGE_OPTIONS_LABEL_MAP: Record<CreditRangeEnum, CreditRangeFilterLabel> = (
  Object.keys(CreditRangeEnum) as CreditRangeEnum[]
).reduce(
  (acc, key) => {
    const rangeLabel = CREDIT_RANGE_LABEL_MAP[key];
    const { min, max } = CREDIT_RANGES[key];
    acc[key] = `${min} - ${max} (${rangeLabel})`;
    return acc;
  },
  {} as Record<CreditRangeEnum, CreditRangeFilterLabel>,
);

export const CARD_FEATURES_OPTIONS = [
  {
    label: CARD_FEATURES_OPTIONS_LABEL_MAP[FilterOffersByType.ALL_CARDS],
    value: FilterOffersByType.ALL_CARDS,
  },
  {
    label: CARD_FEATURES_OPTIONS_LABEL_MAP[FilterOffersByType.NO_ANNUAL_FEE],
    value: FilterOffersByType.NO_ANNUAL_FEE,
  },
  {
    label: CARD_FEATURES_OPTIONS_LABEL_MAP[FilterOffersByType.HAS_INTRO_OFFER],
    value: FilterOffersByType.HAS_INTRO_OFFER,
  },
];

export const SORT_BY_OPTIONS = [
  { label: SORT_BY_OPTIONS_LABEL_MAP[SortOffersByType.FEATURED], value: SortOffersByType.FEATURED },
  {
    label: SORT_BY_OPTIONS_LABEL_MAP[SortOffersByType.HIGHEST_RATING],
    value: SortOffersByType.HIGHEST_RATING,
  },
  {
    label: SORT_BY_OPTIONS_LABEL_MAP[SortOffersByType.LOWEST_ANNUAL_FEE],
    value: SortOffersByType.LOWEST_ANNUAL_FEE,
  },
  {
    label: SORT_BY_OPTIONS_LABEL_MAP[SortOffersByType.LOWEST_APR],
    value: SortOffersByType.LOWEST_APR,
  },
];

/**
 * Map of credit range label (with scores) to credit range enum.
 * @example
 * {
 *   '720 - 850 (Excellent)': CreditRangeEnum.EXCELLENT,
 * }
 */
export const CREDIT_RANGE_LABEL_TO_VALUE: Record<CreditRangeFilterLabel, CreditRangeEnum> =
  Object.fromEntries(
    (
      Object.entries(CREDIT_RANGE_OPTIONS_LABEL_MAP) as [CreditRangeEnum, CreditRangeFilterLabel][]
    ).map(([key, label]) => [label, key]),
  );
